export default {
  UPDATE_RESOURCES: 'UPDATE_RESOURCES',
  DISPLAY_RESOURCES: 'DISPLAY_RESOURCES',
  SELECT_RESOURCES_TO_DOWNLOAD: 'SELECT_RESOURCES_TO_DOWNLOAD',
}